import RenderLoomVideo from './RenderLoomVideo';

export default RenderLoomVideo;
